import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom';
import { EyeIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import AdduserMange from './AdduserMange';
 
const UserMangementTAble = () => {
    const navigate = useNavigate();
  const [addUserMangeOpen, setUserMangeopen] = useState(false);

    const    usermange = [
        {
          sno: 1,
          name: 'Kishore',
            role: 'Manger',
            acess: 'process1',
       
         
        },
        {
          sno: 2,
          name: 'madhesh',
          role: 'superviser',
          acess: 'process2',
        },
      ];
    
      const handleUser = () => {
        setUserMangeopen(true);
        
      };
      const handlebackUser = () => {
        setUserMangeopen(false);
     
      };
      // const handleProjectButtonClick = () => {
      //   navigate('/adduser-management');
      // };
    
      const handleView = ( usermange) => {
        console.log('View client:',  usermange);
        // Handle view logic here, e.g., navigate to a detail page
      };
    
      const handleEdit = (   usermange) => {
        console.log('Edit client:',   usermange);
       };
  return (
    <div> 
      {!addUserMangeOpen ? (
    <><div className="flex justify-end">
          <button
            className="rounded-md py-3  my-3 text-xs px-3 bg-black uppercase mr-2  text-white poppins-medium  "
            onClick={handleUser}
          >
            Add User
          </button>
        </div><div className="w-full overflow-x-auto mt-4">
            <table className="w-full whitespace-no-wrap">
              <thead>
                <tr className="text-xs poppins-semibold tracking-wide text-left text-gray-500 uppercase border-b dark1:border-gray-700 bg-gray-50 dark1:text-gray-400 dark1:bg-gray-800">
                  <th className="px-4 py-3">S.No</th>
                  <th className="px-4 py-3"> Employee Name</th>
                  <th className="px-4 py-3">role</th>
                  <th className="px-4 py-3">acess</th>



                  <th className="px-4 py-3">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white poppins-regular divide-y dark1:divide-gray-700 dark1:bg-gray-800">
                {usermange.map((usermange, index) => (
                  <tr key={index} className="text-gray-700 dark1:text-gray-400">
                    <td className="px-4 py-3 text-sm">{usermange.sno}</td>
                    <td className="px-4 py-3 text-sm">
                      <p className="font-semibold">{usermange.name}</p>
                    </td>
                    <td className="px-4 py-3 text-sm">{usermange.role}</td>
                    <td className="px-4 py-3 text-sm">{usermange.acess}</td>


                    <td className="px-4 py-3 text-sm">
                      <div className="flex space-x-2">
                        {/* View icon */}
                        <EyeIcon
                          className="h-5 w-5 text-gray-500 hover:text-black cursor-pointer"
                          onClick={() => handleView(usermange)} />
                        {/* Edit icon */}
                        <PencilIcon
                          className="h-5 w-5 text-gray-500 hover:text-black cursor-pointer"
                          onClick={() => handleEdit(usermange)} />
                        <TrashIcon
                          className="h-5 w-5 text-gray-500 hover:text-black cursor-pointer"
                          onClick={() => handleEdit(usermange)} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div></>
      ):<AdduserMange onBack={handleUser}/>
      }
  </div>
  )
}
export default UserMangementTAble